var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.54188C0 11.2706 2.70813 14.3713 6.25 15V9.58313H4.375V7.5H6.25V5.83313C6.25 3.95813 7.45813 2.91687 9.16687 2.91687C9.70813 2.91687 10.2919 3 10.8331 3.08313V5H9.875C8.95813 5 8.75 5.45813 8.75 6.04187V7.5H10.75L10.4169 9.58313H8.75V15C12.2919 14.3713 15 11.2712 15 7.54188C15 3.39375 11.625 0 7.5 0C3.375 0 0 3.39375 0 7.54188Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookicon);
export default __webpack_public_path__ + "static/media/facebookicon.621348a1d391bab075b7a60bb621e182.svg";
export { ForwardRef as ReactComponent };